<template>
  <social-sharing 
    :url="shareData.url"
    :title="shareData.title"
    :description="shareData.desc"
    :quote="shareData.quote"
    :hashtags="shareData.hashtags"
    :twitter-user="shareData.twitterUser"
    inline-template
  >    
    <md-menu 
      md-direction="bottom-start" 
      md-align-trigger 
      :md-offset-x="-50"
    >
      <div 
        md-menu-trigger
        class="social share" 
      />
      <md-menu-content 
        class="social-menu" 
        style="min-width: 75px; overflow: hidden;"
      >
        <md-menu-item>
          <network network="facebook">
            <div class="social facebook" />
          </network>
          <network network="twitter">
            <div class="social twitter last-item" />
          </network>
        </md-menu-item>
      </md-menu-content>
    </md-menu>
  </social-sharing>
</template>

<script>
export default {
  name: 'SocialShare',
  props: {
    shareData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.social-menu ul {
  margin: 0px;
  padding: 0px;
  overflow: hidden;
}

.social-menu li {
  /* width: 70px; */
  margin: 0px;
  padding: 0px;
  overflow: hidden;
}
.social-menu li .md-list-item-content {
  padding: 0px;
}
.social {
  float: left;
  width: 30px;
  height: 30px;
  margin-left: 8px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.share {
  opacity: 0.8;
  margin-left: 0px;
  background-image: url('../assets/imgs/share.png');
}
.facebook {
  background-image: url('../assets/imgs/facebook.png');
}
.twitter {
  background-image: url('../assets/imgs/twitter.png');
}
.last-item {
  margin-right: 8px;
}
</style>